<div *ngIf="global_texts" class="d-flex flex-wrap justify-content-around align-items-center mb-4 gap-3 gap-md-5">
  <img class="width-limited" [src]="global_texts.logo_src"/>
  <img class="width-limited" [src]="global_texts.logo_LR_src_vertical">
</div>
